var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88.54 75.03"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-right_svg__cls-1",
    d: "M88.54 37.52c0 1.06-.48 2.07-1.31 2.73L44.71 74.27a3.483 3.483 0 01-3.71.42 3.497 3.497 0 01-1.98-3.15V41.02H7c-3.87 0-7-3.13-7-7h42.52c1.93 0 3.5 1.57 3.5 3.5v26.73l33.42-26.73-33.42-26.74v16.23h-7V3.5c0-1.35.77-2.57 1.98-3.15 1.21-.58 2.65-.42 3.7.42l42.52 34.02c.83.67 1.31 1.67 1.31 2.73z",
    fill: "currentColor"
  })));
}
export default SvgArrowRight;